import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconPackageIssue from '@/icons/PackageIssue.svg';

const ArticleIssueCell = ({ issue }: { issue: string }) => {
  return (
    <div className="bg-danger-100" style={{ padding: 16, borderRadius: 8 }}>
      <Stack row gap="0.5rem" alignItems="flex-start">
        <IconPackageIssue style={{ fontSize: '1.5rem' }} className="text-danger" />
        <Paragraph whiteSpace="pre-wrap">&rdquo;{issue}&rdquo;</Paragraph>
      </Stack>
    </div>
  );
};

export default ArticleIssueCell;
